// The table a game is played on: the 1v1 table (the settings in src/config.ts) or the 2v2 one
// (CONFIG.teams.layout). Everything that reads the mat, its slots or the zones around it reads CONFIG, so
// switching tables means putting the right ones in CONFIG before a game is set up, shown or played:
//   - the browser does it as a table opens (there is only ever one table open there)
//   - the game server does it before it touches a game, since 1v1 and 2v2 games run side by side
import { CONFIG } from '../config.ts';

type Layout = {
  images: { mat: string };
  mat: typeof CONFIG.mat;
  table: typeof CONFIG.table;
  zones: typeof CONFIG.zones;
  slots: typeof CONFIG.slots;
  camera: { start: typeof CONFIG.camera.start; topDown: typeof CONFIG.camera.topDown; bounds: typeof CONFIG.camera.bounds };
};

function current(): Layout {
  return {
    images: { mat: CONFIG.images.mat },
    mat: CONFIG.mat,
    table: CONFIG.table,
    zones: CONFIG.zones,
    slots: CONFIG.slots,
    camera: { start: CONFIG.camera.start, topDown: CONFIG.camera.topDown, bounds: CONFIG.camera.bounds },
  };
}

// the 1v1 table, as the settings have it when the game loads
const ONE = current();
const TWO: Layout = {
  ...CONFIG.teams.layout,
  zones: { ...CONFIG.zones, ...CONFIG.teams.layout.zones },
};

let using: 'one' | 'two' = 'one';

/** Puts the 1v1 table (teams = false) or the 2v2 table (teams = true) in CONFIG. */
export function useLayout(teams: boolean) {
  const want = teams ? 'two' : 'one';
  if (want === using) return;
  using = want;
  const L = teams ? TWO : ONE;
  CONFIG.images.mat = L.images.mat;
  CONFIG.mat = L.mat;
  CONFIG.table = L.table;
  CONFIG.zones = L.zones;
  CONFIG.slots = L.slots;
  CONFIG.camera.start = L.camera.start;
  CONFIG.camera.topDown = L.camera.topDown;
  CONFIG.camera.bounds = L.camera.bounds;
}

/** Which table is in CONFIG right now. */
export function usingTeams() {
  return using === 'two';
}
